import React, { useEffect, useState, useRef } from "react";
import { Handle, NodeProps, Position } from "reactflow";

const CustomNode = ({ data, selected }: NodeProps) => {
  const [label, setLabel] = useState(data.label || data.type);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setLabel(data.label || data.type);
  }, [data.label, data.type]);

  // auto focus quand data.editing est activé
  useEffect(() => {
    if (data.editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [data.editing]);

  const handleBlur = () => {
    if (data.onUpdateLabel) {
      data.onUpdateLabel(label);
    }
  };

  return (
    <div
      style={{
        width: 50,
        height: 50,
        position: "relative",
      }}
    >
      {/* Icône */}
      <img
        src={data.icon}
        alt={data.type}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block",
          backgroundColor: "transparent",
          border: selected ? "2px solid #3B82F6" : "2px solid transparent",
          borderRadius: 8,
          boxShadow: selected ? "0 0 0 3px rgba(59, 130, 246, 0.2)" : "none",
          transition: "all 0.2s ease",
        }}
      />

      {/* 4 HANDLE PAR COTÉ = 8 AU TOTAL */}
      <Handle type="target" position={Position.Top} id="top-target" />
      <Handle type="source" position={Position.Top} id="top-source" />
      <Handle type="target" position={Position.Bottom} id="bottom-target" />
      <Handle type="source" position={Position.Bottom} id="bottom-source" />
      <Handle type="target" position={Position.Left} id="left-target" />
      <Handle type="source" position={Position.Left} id="left-source" />
      <Handle type="target" position={Position.Right} id="right-target" />
      <Handle type="source" position={Position.Right} id="right-source" />

      {/* Label (affichage ou édition) */}
      {(selected || data.label) && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 10,
            background: "#fff",
            padding: "1px 4px",
            border: "1px solid #ccc",
            borderRadius: 4,
            color: "#333",
            whiteSpace: "nowrap",
            minWidth: "30px",
          }}
        >
          {data.editing ? (
            <input
              ref={inputRef}
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              onBlur={handleBlur}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  (e.target as HTMLInputElement).blur();
                }
              }}
              style={{
                fontSize: 10,
                padding: "1px 4px",
                border: "1px solid #ccc",
                borderRadius: 4,
                width: "100%",
              }}
            />
          ) : (
            label
          )}
        </div>
      )}
    </div>
  );
};

export default CustomNode;
